/**
 * Tag-level set diff between two template versions' bodyTags — what a new
 * version added and removed, without opening either docx. Duplicate
 * occurrences are collapsed (presence is what matters for markup), and both
 * lists come back sorted for stable display.
 */

export interface BodyTagDiff {
  added: string[];
  removed: string[];
}

export function diffBodyTags(prev: string[], curr: string[]): BodyTagDiff {
  const prevSet = new Set(prev);
  const currSet = new Set(curr);
  const added = [...currSet].filter((tag) => !prevSet.has(tag)).sort();
  const removed = [...prevSet].filter((tag) => !currSet.has(tag)).sort();
  return { added, removed };
}
